(function () {
    'use strict';

    angular
        .module('core')
        .directive('bookingPaymentOption', bookingPaymentOption);

    function bookingPaymentOption(): ng.IDirective {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                optionId: '@',
                selectedOption: '=',
                expandedOption: '=',
                title: '@',
                iconClass: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=BookingPaymentOption',
            link: function (scope: any): void {
                scope.isSelected = function (): boolean {
                    return scope.selectedOption === scope.optionId;
                };

                scope.isExpanded = function (): boolean {
                    return scope.expandedOption === scope.optionId;
                };

                scope.toggle = function (): void {
                    if (!scope.isSelected()) {
                        scope.selectedOption = scope.optionId;
                        scope.expandedOption = scope.optionId;
                        return;
                    }

                    scope.expandedOption = scope.isExpanded()
                        ? null
                        : scope.optionId;
                };

                scope.onKeydown = function ($event: JQueryKeyEventObject): void {
                    if ($event.keyCode === 13 || $event.keyCode === 32) {
                        $event.preventDefault();
                        scope.toggle();
                    }
                };
            }
        };
    }
})();
